import Activity from './Activity'

export default function ActivityMember() {
  return <Activity />
}
